// useClickAway.js
import { useEffect, useRef } from 'react';
import {
  getIosVersion,
  getBrowserVersion,
  getIsIosSafari,
  getIsOnDesktopSafari,
} from '../resource/getUserAgent.js';

const isIosSafariBelow12 = getIsIosSafari() && getIosVersion().major <= 12;
const isSafariBelow12 =
  getIsOnDesktopSafari() && getBrowserVersion().major <= 12;
const isBelowSafari12 = isIosSafariBelow12 || isSafariBelow12;
// https://github.com/swaglive/swag-webapp/pull/7500#discussion_r1478058355
const events = isBelowSafari12 ? ['mousedown', 'touchstart'] : ['pointerdown'];

const useClickAway = (ref, onClickAway) => {
  const savedCallback = useRef(onClickAway);
  useEffect(() => {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  useEffect(() => {
    const handler = event => {
      const { current: el } = ref;
      el && !el.contains(event.target) && savedCallback.current(event);
    };

    for (const eventName of events) {
      document.addEventListener(eventName, handler);
    }
    return () => {
      for (const eventName of events) {
        document.removeEventListener(eventName, handler);
      }
    };
  }, [ref]);
};

export default useClickAway;
